import React, { useEffect, useReducer } from "react";
import * as notify from "../../../../shared/notify";

import LightingForm from "./components/lighting-form";
import TaskNav from "../../../task-nav/task-nav";

import { sendSingleAttributeData } from "../../lib/attribute-data";
import { reducer, initialState } from "./reducers";
import { useKeyboardShortcut } from "../../../../shared/hooks/hotkeys";

const LightingIndex = (props) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const hotkeys = useKeyboardShortcut();

    useEffect(() => {
        if (Object.getOwnPropertyNames(props.value).length > 0) {
            dispatch({ type: "SAVE_PANEL", panel: props.value, isDirty: false });
        }
    }, []);

    useEffect(() => {
        switch (hotkeys) {
            case "SAVE":
                savePanel();
                break;
            default:
                break;
        }
    }, [hotkeys]);

    const updateField = (key, value) => {
        dispatch({ type: "UPDATE_STATE", key: key, value: value });
    };

    const savePanel = async () => {
        try {
            if (!props.skipInternalSave) {
                const response = await sendSingleAttributeData(props.codingWipKey, props.taskId, props.sourcePage, { definition: props.attribute.uuid, type: props.attribute.componentType, value: state.panel });

                if (!response) {
                    return false;
                }

                 notify.success("Saved");
            }

            props.updateOnChange(props.attribute.uuid, state.panel, props.attribute.componentType);
            dispatch({ type: "SET_DIRTY_FLAG", isDirty: false });

            return true;
        } catch (err) {
            notify.error(err);

            return false;
        }
    };

    const closePanel = async () => {
        if (state.isDirty) {
            const confirm = await notify.confirm("You have unsaved data.  Are you sure you want to navigate away? Unsaved data will be lost!");

            if (!confirm) {
                return;
            }
        }

        props.closeModal();
    };

    return (
        <div className="container">
            <TaskNav>
                <div className="button-group">
                    <button className="button" onClick={closePanel}>
                        Back
                    </button>
                    <h1 className="txt-center">Lighting Facts</h1>
                    <button className="button -primary" onClick={savePanel}>
                        Save
                    </button>
                </div>
            </TaskNav>
            <LightingForm panel={state.panel} updateField={updateField} />
        </div>
    );
};

export default LightingIndex;
